/** Mandatory-field asterisk — matches PMC / company form required markers. */
export function RequiredAsterisk() {
  return (
    <span className="font-semibold text-[#dc2626]" aria-hidden>
      *
    </span>
  )
}
